export default {
  name: 'Header',
  computed: {
    modal() {
      return this.$store.state.loginModal;
    },
    searchActive() {
      return this.$store.state.searchActive;
    }
  },
  methods: {
    toggleSearch: function() {
      this.searchActive = !this.searchActive
    }
  },
}
